import {AbstractVisualFeature, allVisuals} from '../../visual-feature.js';

import {racingConfig} from './racing.factory';

class RacingFeature extends AbstractVisualFeature {
    getVisualConfig() {
        return racingConfig();
    }
}

export const Racing = FEATURES.racing ? new RacingFeature(allVisuals) : null;
